var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-api-doc"},[_c('div',{staticClass:"doc-inner"},[(_vm.loading)?_c('div',{staticClass:"doc-tip"},[_vm._v("文档加载中…")]):(_vm.error)?_c('div',{staticClass:"doc-tip"},[_vm._v("文档加载失败,请稍后重试。")]):_c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }